const renderWithLinks = (text)=> {
  // Regex to catch http(s) URLs
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  return text.split(urlRegex).map((part, i) => {
    if (urlRegex.test(part)) {
      return (
        <a key={i} href={part} target="_blank" rel="noopener noreferrer">
          {part}
        </a>
      );
    } else {
      // Replace \n with <br />
      const lines = part.split(/\n/);
      return lines.map((line, j) =>
        j === 0 ? line : [<br key={j} />, line]
      );
    }
  });
}

export default renderWithLinks;